import { OrganizationCodes, ClientType } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, colors, overlayColors } from '@revenuemarket/design';
import { Typography } from 'antd';

interface Props {
  organizationCode: OrganizationCodes;
  organizationName: string;
  loginName: string;
  clientTypes: ClientType[];
  status: 'CONNECTED' | 'DISCONNECTED';
  isHighlighted?: boolean;
  actionable?: React.ReactNode;
}

const convertClientTypes = (clientType: ClientType) => {
  if (clientType === 'CREDIT') {
    return '신용카드';
  }
  if (clientType === 'DEBIT') {
    return '체크카드';
  }
  if (clientType === 'RESEARCH') {
    return '연구비카드';
  }
  return '';
};

export const CardConnectionItem: React.FC<Props> = ({
  organizationCode,
  organizationName,
  loginName,
  clientTypes,
  status,
  isHighlighted,
  actionable,
}) => {
  const isDisconnected = status === 'DISCONNECTED';
  return (
    <Flex
      style={{
        width: '100%',
        padding: '7px 16px',
        borderRadius: 6,
        border: `1px solid ${
          isHighlighted
            ? colorTokens.borderPrimary
            : isDisconnected
              ? colorTokens.textDanger
              : colorTokens.borderDefault
        }`,
        backgroundColor: isHighlighted ? overlayColors.primary[16] : '',
      }}
      justify="space-between"
      align="center"
    >
      <Flex gap={16} align="center">
        <Flex style={{ minWidth: 24 }}>
          <img
            src={`https://static.clobe.ai/logo__card-${organizationCode}.png`}
            alt={organizationName}
            style={{
              width: 24,
              height: 34,
            }}
          />
        </Flex>
        <Flex direction="column" gap={4}>
          <Typography.Text
            style={{
              color: colors.grayscaleBlack,
            }}
          >
            {loginName || '삭제된 공동인증서'}
          </Typography.Text>
          {clientTypes.length > 0 && (
            <Typography.Text type="secondary" style={{ fontSize: '10px' }}>
              {clientTypes.map(convertClientTypes).join(' · ')}
            </Typography.Text>
          )}
          {status === 'DISCONNECTED' && (
            <Typography.Text style={{ fontSize: '10px' }} type="danger">
              로그인할 수 없는 상태입니다. 우측 버튼을 클릭해 연동 중단 후 새 계정을 추가해주세요.
            </Typography.Text>
          )}
        </Flex>
      </Flex>
      {actionable && <Flex>{actionable}</Flex>}
    </Flex>
  );
};
